// web/src/store/utilitySlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '@api/index';

// Define the initial state
interface UtilityState {
  loading: boolean;
  error: string | null;
  searchSuggestions: object | null;
}

const initialState: UtilityState = {
  loading: false,
  error: null,
  searchSuggestions: null,
};

// Async thunk
export const getSearchSuggestions = createAsyncThunk<
  object,
  string,
  { rejectValue: string }
>('utility/getSearchSuggestions', async (query, { rejectWithValue }) => {
  try {
    const response = await apiInstance.utility.getSearchSuggestions(query);
    return response.data.data;
  } catch (error: any) {
    return rejectWithValue(
      error.message || 'Failed to fetch search suggestions',
    );
  }
});

// Slice
const utilitySlice = createSlice({
  name: 'utility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSearchSuggestions.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.searchSuggestions = null;
    });
    builder.addCase(getSearchSuggestions.fulfilled, (state, action) => {
      state.loading = false;
      state.searchSuggestions = action.payload;
    });
    builder.addCase(getSearchSuggestions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to fetch search suggestions';
    });
  },
});

export default utilitySlice.reducer;
